import axios from "axios";
import axiosRetry from "axios-retry";

export default function getAxiosObj() {
  axiosRetry(axios, {
    retries: 3, // number of retries
    retryDelay: (retryCount) => {
      console.log(`retry attempt: ${retryCount}`);
      return retryCount * 2000; // time interval between retries
    },
    retryCondition: (error: any) => {
      return (
        error.code === "ERR_NETWORK" &&
        error?.config?.url?.indexOf("GetProfile?user_handle") !== -1
      );
    },
  });

  axios.interceptors.response.use(
    (response) => {
      if (response && response.status === 429) {
        // alert(response.status);
      }
      if (response && response.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      }
      return response;
    },
    (error) => {
      if (error && error.response && error.response.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      } else {
        if (error && error.response && error.response.status === 452) {
          console.log(error);
        }
        if (error && error.response && error.response.status === 451) {
          console.log(error);
        }
        if (error && error.response && error.response.status === 500) {
          console.log(error);
          return error;
        }
        return error;
      }
    }
  );

  return axios;
}
